/**
 * Handles the Newsletter Modal toggle on mobile devices
 */
function initMobileNewsletter() {
    const elements = {
        toggle: document.getElementById('toggleNewsletter'),
        modal: document.getElementById('newsletterModal'),
        close: document.getElementById('closeNewsletter'),
    };

    if (!elements.toggle || !elements.modal) return;

    const modalActiveClass = 'newsletter-modal--active';

    const toggleModal = (forceClose = false) => {
        if (forceClose === true) {
            elements.modal.classList.remove(modalActiveClass);
            document.body.style.overflow = '';
        } else {
            const isOpen = elements.modal.classList.toggle(modalActiveClass);
            // Prevent background scrolling when modal is open
            document.body.style.overflow = isOpen ? 'hidden' : '';
        }
    };

    elements.toggle.addEventListener('click', () => toggleModal());

    if (elements.close) {
        elements.close.addEventListener('click', () => toggleModal(true));
    }

    // Optional: Close on "Escape" key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && elements.modal.classList.contains('is-active')) {
            toggleModal(true);
        }
    });
}

document.addEventListener('DOMContentLoaded', initMobileNewsletter);
